export const LOGOS = [
    {
        src: "https://s3-us-west-2.amazonaws.com/apps.static.resources/afterpay_green.png"
    },
    {
        src: "https://s3-us-west-2.amazonaws.com/apps.static.resources/afterpay_black.png"
    },
    {
        src: "https://s3-us-west-2.amazonaws.com/apps.static.resources/afterpay_white.png"
    },
]